import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import SEO from "@/components/SEO";

const TermsAndConditions: React.FC = () => {
  return (
    <PageLayout title="Terms & Conditions">
      <SEO
        title="Terms of Service — RemoteViz.ai"
        description="The terms and conditions that govern your use of the RemoteViz.ai remote viewing platform."
        path="/terms-and-conditions"
      />
      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-4xl mb-8">Terms of Service</h1>
        
        <div className="prose prose-gray max-w-none">
          <p className="text-muted-foreground mb-6"><strong>Effective Date:</strong> [Date]</p>
          
          <h2 className="text-2xl font-semibold mb-4 text-primary">1. Acceptance of Terms</h2>
          <p className="text-foreground mb-6">
            By using RemoteViz.ai, you agree to these Terms of Service ("Terms") and our Privacy Policy. If you do not agree, you may not use the Services.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-primary">2. Use of the Services</h2>
          <p className="text-foreground mb-4">You must:</p>
          <ul className="list-disc pl-6 text-foreground space-y-1 mb-6">
            <li>Be at least 18 years old or have legal capacity to enter into contracts.</li>
            <li>Provide accurate account information.</li>
            <li>Use the Services only for lawful purposes and in accordance with these Terms.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">3. User Content</h2>
          
          <div className="mb-6">
            <h3 className="text-xl font-medium mb-2 text-[#5F436C]">Your Content</h3>
            <p className="text-foreground">
              You retain all rights to content you upload or generate. You grant us a worldwide, non-exclusive license to store, process, and display your content solely to operate the Services.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-medium mb-2 text-[#5F436C]">Prohibited Content</h3>
            <p className="text-foreground mb-4">You agree not to upload or share content that:</p>
            <ul className="list-disc pl-6 text-foreground space-y-1">
              <li>Violates laws or regulations.</li>
              <li>Infringes intellectual property rights.</li>
              <li>Contains malicious code or viruses.</li>
              <li>Is abusive, harassing, or hateful.</li>
            </ul>
          </div>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">4. AI-Generated Outputs</h2>
          <p className="text-foreground mb-6">
            You acknowledge that AI-generated outputs are produced by automated systems (including OpenAI models) and may contain inaccuracies. You are responsible for evaluating the suitability of outputs before relying on them.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">5. Account Security</h2>
          <p className="text-foreground mb-6">
            You are responsible for maintaining the confidentiality of your login credentials and for any activity under your account.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">6. Termination</h2>
          <p className="text-foreground mb-6">
            We may suspend or terminate your access at our discretion, including for violation of these Terms or misuse of the Services.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">7. Disclaimers</h2>
          <p className="text-foreground mb-6">
            The Services are provided "as is" without warranties of any kind. We disclaim all warranties, including merchantability, fitness for a particular purpose, and non-infringement.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">8. Limitation of Liability</h2>
          <p className="text-foreground mb-6">
            To the fullest extent permitted by law, RemoteViz.ai and its affiliates will not be liable for indirect, incidental, consequential, or punitive damages, or loss of data, profits, or goodwill arising from your use of the Services.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">9. Indemnification</h2>
          <p className="text-foreground mb-6">
            You agree to indemnify and hold harmless RemoteViz.ai from any claims, damages, or expenses arising from your use of the Services or your violation of these Terms.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">10. Governing Law</h2>
          <p className="text-foreground mb-6">
            These Terms are governed by the laws of [Your Jurisdiction]. Any disputes will be resolved exclusively in the courts of [Your Jurisdiction].
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">11. Changes to the Terms</h2>
          <p className="text-foreground mb-6">
            We may update these Terms from time to time. Changes will be posted on this page, and your continued use after changes means you accept them.
          </p>

          <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">12. Contact Us</h2>
          <p className="text-foreground">
            If you have questions, please email [support@remoteviz.ai].
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default TermsAndConditions;